module.exports = __webpack_public_path__ + "img/logo_2fa.769fe742.png";